export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  PROFILE_CREATION_PENDING: {
    Title: 'Profile Creation Pending',
    Color: '#FFD54F',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
  },
};
